import LetterHead from "./LetterHead";
import ContactMailPhone from "./ContactMailPhone";
import BankAccountAndTaxNumbers from "./BankAccountAndTaxNumbers";

const ProfileContactInfo = ({ language, documentType }) => {

  return (
    <>
      <LetterHead />
      <ContactMailPhone language={language} />
      <BankAccountAndTaxNumbers
        language={language}
        documentType={documentType}
      />
    </>
  );
};

export default ProfileContactInfo;
